import { makeStyles, Theme } from '@material-ui/core';

import { monochrome } from '../../theme/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  page: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '32px',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: '20px',
    },
  },
  intro: {
    width: '252px',
    flex: 'none',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    position: 'sticky',
    top: 0,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      position: 'static',
    },
  },
  introText: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
  },
  introTitle: {
    fontSize: '24px',
    lineHeight: '32px',
    fontWeight: 600,
  },
  introDescription: {
    lineHeight: '20px',
    color: theme.palette.text.secondary,
  },
  content: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '28px',
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    borderRadius: '16px',
    border: `1px solid ${theme.palette.divider}`,
    overflow: 'hidden',
  },
  header: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '16px',
    padding: '20px 24px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  headerText: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
  },
  title: {
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 600,
  },
  description: {
    lineHeight: '20px',
    color: theme.palette.text.secondary,
    maxWidth: '760px',
  },
  headerControls: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    flex: 'none',
  },
  body: {
    padding: '20px 24px 24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '16px',
    padding: '16px 24px 20px',
  },
  footerActions: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    marginLeft: 'auto',
  },
  // A card inside another card's body — one alert in a tile. Declared after the card rules
  // above so the tighter radius and padding win.
  nestedCard: {
    borderRadius: '12px',
  },
  nestedHeader: {
    padding: '14px 16px',
  },
  nestedBody: {
    padding: '16px 16px 20px',
  },
  nestedFooter: {
    padding: '12px 16px 16px',
  },
  pill: {
    alignSelf: 'flex-start',
    padding: '3px 10px',
    borderRadius: '12px',
    fontSize: '11px',
    lineHeight: '16px',
    fontWeight: 600,
  },
  sectionHeader: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  sectionDescription: {
    lineHeight: '20px',
    color: theme.palette.text.secondary,
    maxWidth: '760px',
  },
  sectionLabel: {
    fontSize: '12px',
    lineHeight: '16px',
    fontWeight: 600,
    letterSpacing: '1px',
    textTransform: 'uppercase',
    color: monochrome.medium,
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  sectionCards: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  pair: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: '16px',
    alignItems: 'start',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: 'minmax(0, 1fr)',
    },
  },
  optionList: {
    display: 'flex',
    flexDirection: 'column',
  },
  option: {
    // The divider sits on the option as a whole, so an option's own revealed
    // details never get a line drawn between them and their label.
    '&:not(:last-child)': {
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
  },
  optionRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '16px',
    padding: '14px 0',
    cursor: 'pointer',
  },
  optionText: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
  },
  optionLabel: {
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: 500,
  },
  optionHint: {
    fontSize: '12px',
    lineHeight: '18px',
    color: theme.palette.text.secondary,
  },
  optionDetails: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    padding: '4px 0 8px',
  },
  stepper: {
    display: 'flex',
    alignItems: 'center',
    height: '36px',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '10px',
    overflow: 'hidden',
  },
  stepperButton: {
    width: '34px',
    height: '100%',
    minWidth: 'unset',
    borderRadius: 0,
    padding: 0,
    color: theme.palette.text.secondary,
  },
  stepperValue: {
    minWidth: '44px',
    textAlign: 'center',
    fontSize: '14px',
    fontWeight: 600,
    borderLeft: `1px solid ${theme.palette.divider}`,
    borderRight: `1px solid ${theme.palette.divider}`,
    lineHeight: '34px',
  },
}));
